import { get, getBlob } from '../../utils/axios'

const serializeParams = (params) => {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v))
    } else {
      searchParams.append(key, value)
    }
  })
  return searchParams.toString()
}

export const listReportAttendanceSummaryAPI = async (params) => {
  const qs = serializeParams(params)
  return await get(`report/attendance/summary?${qs}`)
}

export const exportReportAttendanceSummaryAPI = async (params) => {
  const qs = serializeParams(params)
  return await getBlob(`report/attendance/summary/export?${qs}`)
}

export const getReportAttendanceDropStaffAPI = async (params, headers = {}) => {
  return await get('report/attendance/drop/staff', params, headers)
}

export const getReportAttendanceDropSummaryStatusAPI = async () => {
  return await get('report/attendance/drop/summary/status')
}

export const getReportAttendanceDropPositionsAPI = async (param) => {
  return await get('report/attendance/drop/positions', param)
}

export const getReportAttendanceDropReportToAPI = async (
  params,
  headers = {}
) => {
  return await get('report/attendance/drop/reportTo', params, headers)
}
